import React, { useState } from 'react';
import {
  Button
} from 'reactstrap';
import Icon from 'jsx/components/core/icons/Icon';
import Listview from "../../core/form/components/Listview";
import OrgTestCodeModal from './OrgTestCodeModal';

const OrgTestCodesLsv = (props) => {
  const {
    orgId,
    rows,
    type,
    checkAccess,
    onRemove
  } = props;

  const [isModalOpen, setModal] = useState(false);

  const openModal = () => {
    setModal(true);
  }

  const renderRows = (headers, row) => {
    const tableTd = headers.map((header, index) => {
      switch (header.field) {
        case 'remove': return (
          <td key={index} className={header.classes}><Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => { onRemove(row.id) }} /></td>
        )
        case 'sample_type': return (
          <td key={index} className={header.classes}>{row.sample_type.name}</td>
        )
        case 'code': return (
          <td key={index} className={header.classes}>{row.test_code.code}</td>
        )
        case 'is_default': return (
          <td key={index} className={header.classes}>{(row[header.field] ? 'Yes' : 'No')}</td>
        )
        default: return (
          <td key={index} className={header.classes}>{row[header.field]}</td>
        )
      }
    });

    return tableTd;
  }

  const headers = [
    { caption: 'Sample Type', field: 'sample_type', classes: 'text-left' },
    { caption: 'Code', field: 'code', classes: 'text-left' },
    { caption: 'Default', field: 'is_default', classes: 'text-center' },
    { caption: '', field: 'remove', classes: 'text-center text-danger' },
  ]

  const tableHeadTh = headers.map((header, index) =>
    <th key={index} className={header.classes}>{header.caption}</th>
  );

  let tableBodyTr = (<tr></tr>);
  const haveRows = (rows && rows.length > 0);
  if (haveRows) {
    tableBodyTr = rows.map((row, index) =>
      <tr key={index} style={{cursor: 'pointer'}}>
        {renderRows(headers, row)}
      </tr>
    );
  }

  const iconName = 'laptop-code';
  const emptyCaption = 'No codes found';

  return (
    <React.Fragment>
      <OrgTestCodeModal setModal={setModal} isOpen={isModalOpen} orgId={orgId} type={type} />
      <div className="d-flex justify-content-end">
        <Button disabled={!checkAccess('labRecordUpdate')} color="success" size="sm" onClick={() => openModal(null)}>Link Test Code</Button>
      </div>
      <Listview rows={rows} tableHeadTh={tableHeadTh} tableBodyTr={tableBodyTr} iconName={iconName} emptyCaption={emptyCaption} />
    </React.Fragment>
  );
}

export default OrgTestCodesLsv;
